import jwtDecode from 'jwt-decode';

export function isTokenNearExpiry(token) {
  if (!token) {
    return false;
  }

  const decodedToken = jwtDecode(token);
  const nowMs = Date.now();
  const expRaw = Number(decodedToken.exp);
  // JWT exp is typically in seconds, but some issuers use milliseconds.
  const expMs = expRaw > 1e12 ? expRaw : expRaw * 1000;
  const timeRemainingMs = expMs - nowMs;

  const rawRenewTime = Number(process.env.VUE_APP_RENEW_TOKEN_TIME);
  // Accept seconds (e.g. 18) or milliseconds (e.g. 18000).
  const renewThresholdMs = Number.isFinite(rawRenewTime)
    ? (rawRenewTime > 1000 ? rawRenewTime : rawRenewTime * 1000)
    : 0;

  return timeRemainingMs <= renewThresholdMs;
}
